import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Timetable } from './timetable.interface';
import timetableService from './timetable.service';

export interface TimetableState { }

const TimetableStore: Module<TimetableState, StoreState> = {
   namespaced: true,

   state: {},

   getters: {},

   mutations: {},

   actions: {
      async delete(context, { timetable_id }: { timetable_id: number }) {
         return await timetableService.delete(timetable_id).then((response) => {
            context.commit('board/removeTimetableFromBoard', timetable_id, { root: true });
            return response;
         });
      },
      async post(context, { board_id, timetable }: { board_id: number; timetable: Timetable }) {
         const body = timetable;
         body['board_id'] = board_id;

         return await timetableService.post(body).then((response) => {
            context.commit('board/addTimetableToBoard', response, { root: true });
            return response;
         });
      },
      async patches(
         context,
         { timetable_id, patches }: { timetable_id: number; patches: Array<{ op: string; path: string; value: any }> },
      ) {
         const BODY = patches.map((patch) => {
            return {
               op: 'replace',
               path: patch.path,
               value: patch.value,
            };
         });

         return await timetableService.patch(timetable_id, BODY).then((response) => {
            context.commit('board/updateTimetablePropertiesInBoard', { patches, updated_timetable: response }, { root: true });
            return response;
         });
      },
      async resequenceTimetableWeeks(
         context,
         {
            timetable_id,
            timetable_week_ids_with_sequence,
         }: { timetable_id: number; timetable_week_ids_with_sequence: Array<{ id: number; sequence: number }> },
      ) {
         const BODY = { timetable_weeks: timetable_week_ids_with_sequence };
         return await timetableService.resequenceTimetableWeeks(timetable_id, BODY);
      },
   },
};

export default TimetableStore;
